import { render, staticRenderFns } from "./BindStoreDetail.vue?vue&type=template&id=98723b7c&scoped=true&"
import script from "./BindStoreDetail.vue?vue&type=script&lang=ts&"
export * from "./BindStoreDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BindStoreDetail.vue?vue&type=style&index=0&id=98723b7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98723b7c",
  null
  
)

export default component.exports